import React from "react";
import UserScreenWindow from "../Components/UserScreenWindow";

function WaterServiceUser() {
  return (
    <UserScreenWindow label="Water Delivery">WaterServiceUser</UserScreenWindow>
  );
}

export default WaterServiceUser;
